const Dept = () => import('@/views/main/system/dept/Dept.vue')
export default {
  path: '/main/system/dept',
  name: 'Dept',
  component: Dept,
  children: []
}
